// extracted by mini-css-extract-plugin
module.exports = {"checkbox":"BankAccountInfo_checkbox__1F_1u"};